import type { AcademyApi } from '@mathflat/domain/@entities/Academy/api'

import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

type ResponseAcademy = DefaultResponse<res.Academy>

// 기관 API
const academyApi = {
  // 기관 가져오기
  getAcademies() {
    return maxios.get<res.Academy>('/academies')
  },
  // 기관 수정하기
  patchAcademies(data: req.Academy) {
    return maxios.patch('/academies', data)
  },
  // patchAcademies는 고객정보 수정 시 사용하고, patchCustomerType은 4주간만 띄우는 팝업에서 사용하기 때문에 분리함
  patchCustomerType(data: req.AcademyCustomerType) {
    return maxios.patch('/academies', data)
  },
  // NICE 인증 성공 후 발신번호 변경을 요청한다
  // 사용자 정보 복호화 및 Draft 저장
  patchNiceAuthSuccess({ encodeData }: req.EncodeData, type: req.NiceAuthSuccessType) {
    return maxios.patch<DefaultResponse<res.NiceAuthSuccess>>(
      `/academies/nice-auth-success/${type}`,
      encodeData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },

  postMetaData: async (data: req.AcademyMetaData) => {
    return maxios.post('/academies/metadata', data)
  },
  patchMetaData: async (data: req.AcademyAttendanceSmsService) => {
    return maxios.patch('/academies/metadata', data)
  },
  putMetaData: async <T extends 'v1' | 'v2'>(
    data: T extends 'v1' ? req.PutAcademyMetaData : req.AcademyMetaDataV2,
    version: T = 'v2' as T,
  ) => {
    if (version === 'v1') {
      return maxios.put('/academies/metadata', data)
    }
    return maxios.put('/academies/metadata/v2', data)
  },
  postFreePremium: async (data: req.FreePremium) => {
    return maxios.post('/academies/free-premium', data)
  },
  postSubscriptionOffer: (
    data: AcademyApi.Request.SubscriptionOffer,
    token: string,
    academyId: string,
  ) => {
    return maxios.post(`/academies/${academyId}/subscription-offer`, data, {
      headers: { 'x-subscription-offer-token': token },
    })
  },
  initializeAcademy: () => {
    return maxios.post('/academies/initialize')
  },
}
export default academyApi
